// extracted by mini-css-extract-plugin
module.exports = {"memory":"memory__3zWHQ","label":"label__TCb_x","container":"container__o4iXE","group":"group__3Rmue"};